import * as React from 'react';
import { DropdownMenuItem } from '@symphony-ui/uitoolkit-components';
import DownloadContext from 'contexts/DownloadContext';
import ApiServerRequest from 'models/ApiServerRequest';
import ApiServerURL from 'models/ApiServerUrl';
import { sendError, sendFetchError } from 'utils/messageUtils';
import PopupButton from '../action/PopupButton';
import ColumnPicker from '../ColumnPicker';
import TableSettingsSaveModal from '../TableStateSaveModal';
import TableFormatSettingsModal from './TableFormatSettingsModal';
import TableSettingsModal from './TableSettingsModal';
import TableSettings from 'models/TableSettings';
import UserContext from 'contexts/UserContext';
const TableSettingsButton = function TableSettingsButtonElement({ current, original, setCurrent, setOriginal, table }) {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const { checkEditable } = React.useContext(UserContext);
    const [showColumnPicker, setShowColumnPicker] = React.useState(false);
    const [showTableSettingsModal, setShowTableSettingsModal] = React.useState(false);
    const [showTableSettingsSaveModal, setShowTableSettingsSaveModal] = React.useState(false);
    const [showTableFormattingModal, setShowTableFormattingModal] = React.useState(false);
    const saveSettings = React.useCallback(() => {
        (async () => {
            const init = { body: JSON.stringify(current), headers: { 'Content-Type': 'application/json' }, method: 'POST' };
            const request = new ApiServerRequest('/syndicate/table-settings', init);
            try {
                const body = await apiFetchJson(request);
                const updated = new TableSettings(body);
                setCurrent(updated);
                setOriginal(updated);
            }
            catch (error) {
                sendFetchError('Unable to save table settings', error, request);
            }
        })();
    }, [apiFetchJson, current, setCurrent, setOriginal]);
    const loadSettings = React.useCallback(async (id, signal) => {
        const url = new ApiServerURL('/syndicate/table-settings/find');
        url.searchParams.append('id', id);
        const request = new ApiServerRequest(url);
        const body = await apiFetchJson(request, signal);
        const updated = new TableSettings(body);
        setOriginal(updated);
        return body;
    }, [apiFetchJson, setOriginal]);
    const childFn = React.useCallback((close) => {
        const list = [
            (React.createElement(DropdownMenuItem, { key: "viewall", onClick: () => {
                    setShowColumnPicker(true);
                    close();
                } }, "View Saved Settings")),
            (React.createElement(DropdownMenuItem, { key: "saveSettings", onClick: () => {
                    setShowTableSettingsSaveModal(true);
                    close();
                } }, current.id === undefined ? 'Save current Settings' : 'Save a Copy')),
            (React.createElement(DropdownMenuItem, { key: "resetstate", onClick: () => {
                    setCurrent(TableSettings.create(current.table));
                    localStorage.removeItem(`${current.table}-table-settings`);
                    close();
                } }, "Reset to Default"))
        ];
        if (original !== undefined && checkEditable(current) && !current.equals(original)) {
            list.push((React.createElement(DropdownMenuItem, { key: "savesettings", onClick: () => {
                    setShowTableSettingsSaveModal(true);
                    close();
                } }, "Save curent settings")));
        }
        else {
            list.push((React.createElement(DropdownMenuItem, { key: "saveSettings", onClick: () => {
                    setShowTableSettingsSaveModal(true);
                    close();
                } }, "Save as New")));
            list.push((React.createElement(DropdownMenuItem, { key: "updateSettings", onClick: () => {
                    saveSettings();
                    close();
                } }, "Update current Settings")));
        }
        list.push((React.createElement(DropdownMenuItem, { key: "formats", onClick: () => {
                setShowTableFormattingModal(true);
                close();
            } }, "Formatting")));
        list.push((React.createElement(DropdownMenuItem, { key: "columnpicker", onClick: () => {
                setShowColumnPicker(true);
                close();
            } }, "Select Columns")));
        return list;
    }, [checkEditable, current, original, saveSettings, setCurrent]);
    React.useEffect(() => {
        const abortController = new AbortController();
        const { id } = current;
        if (id !== undefined && original === undefined) {
            (async () => {
                try {
                    await loadSettings(id, abortController.signal);
                }
                catch (error) {
                    sendError("Unable to load settings", error);
                }
            })();
        }
        return () => abortController.abort();
    }, [loadSettings, current, original]);
    const setFormatting = React.useCallback((formatting) => {
        const updated = current.setFormatting(formatting);
        setCurrent(updated);
    }, [current, setCurrent]);
    return (React.createElement(React.Fragment, null,
        showColumnPicker
            ? React.createElement(ColumnPicker, { onClose: () => setShowColumnPicker(false), table: table }) : null,
        showTableSettingsSaveModal
            ? (React.createElement(TableSettingsSaveModal, { close: () => setShowTableSettingsSaveModal(false), tableSettings: current, setTableSettings: setCurrent })) : undefined,
        showTableSettingsModal
            ? (React.createElement(TableSettingsModal, { close: () => setShowTableSettingsModal(false), deleteFn: () => {
                    //
                }, openFn: () => {
                    //
                }, tableName: current.table })) : undefined,
        showTableFormattingModal
            ? (React.createElement(TableFormatSettingsModal, { close: () => setShowTableFormattingModal(false), formatting: current.formatting, setFormatting: setFormatting })) : undefined,
        React.createElement(PopupButton, { childFn: childFn, iconName: "settings", style: { transform: 'translate(-9rem, -0.5rem)' } })));
};
export default TableSettingsButton;
